import * as React from 'react';
import { parseCookies } from './parseCookies';
const XingHubContext = React.createContext({
    fetch: global.fetch,
});
export const XingHubProvider = XingHubContext.Provider;
export const useXingHub = () => {
    const { cookies, fetch = global.fetch, ...rest } = React.useContext(XingHubContext);
    // SSR doesn't run useEffect, so we need to default a default value
    const [cookieVal, setCookieVal] = React.useState(cookies || {});
    React.useEffect(() => {
        // if we're on the client and don't have cookies, we're on hops 10
        if (!cookies || Object.keys(cookies).length === 0) {
            setCookieVal(parseCookies(document.cookie));
        }
    }, []);
    return {
        cookies: cookieVal,
        fetch,
        ...rest,
    };
};
// The type T represents all types you can pass through
// the HOC onto the wrapped component
// The comma is there to distinguish it from an opening tag
export const injectXingHub = (WrappedComponent) => {
    return function withXingHub(props) {
        const xingHubProps = useXingHub();
        return React.createElement(WrappedComponent, { ...xingHubProps, ...props });
    };
};
//# sourceMappingURL=XingHub.js.map